//empty for future user actions
import * as actionTypes from "../types";
import * as firebase from "../../utils/firebase";
import { onSnapshot } from "firebase/firestore";



export const getBooks = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getBooks(), book => {
            var books = [];
            book.forEach((doc) => {
                books.push({ ...doc.data(), id: doc.id })
            });
            if (books.length > 0) {
                dispatch({
                    type: actionTypes.GET_BOOK,
                    payload: {
                        books: books,
                        bookEmpty: false
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_BOOK,
                    payload: {
                        books: books,
                        bookEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}

export const resetBooks = () => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.GET_BOOK,
            payload: {
                books: [],
                bookEmpty: false
            }
        });
    } catch (err) {
        console.error(err);
    }
}


export const selectBook = (bookObject) => async (dispatch) => {
    try {
        if (bookObject) {
            localStorage.setItem("selectedBook", JSON.stringify(bookObject))
            dispatch({
                type: actionTypes.SELECT_BOOK,
                payload: bookObject
            });
        }
    } catch (err) {
        console.error(err);
    }
};

export const getSelectedBook = () => async (dispatch) => {
    try {
        var bookID = localStorage.getItem("selectedBook") ? JSON.parse(localStorage.getItem("selectedBook")) : false;
        if (bookID) {
            dispatch({
                type: actionTypes.SELECT_BOOK,
                payload: bookID
            });
        }
    } catch (err) {
        console.error(err);
    }
}

export const getBookmarks = () => async (dispatch) => {
    try {
        firebase.getBookmarks().then((data) => {
            if (data) {
                dispatch({
                    type: actionTypes.GET_BOOKMARKS,
                    payload: {
                        bookmarks: data.data().bookmarks,
                        bookmarkEmpty: false
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_BOOKMARKS,
                    payload: {
                        bookmarks: [],
                        bookmarkEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
};

export const getReservedBooks = () => async (dispatch) => {
    try {
        firebase.getBookmarks().then((data) => {
            if (data) {
                if (data.data().reservedBooks.length > 0) {
                    dispatch({
                        type: actionTypes.GET_RESERVED,
                        payload: {
                            reservedBooks: data.data().reservedBooks,
                            reserveEmpty: false
                        }
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_RESERVED,
                    payload: {
                        reservedBooks: [],
                        reserveEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
};

export const getBookmarkedBook = () => async (dispatch) => {
    try {
        firebase.getBookmarks().then((data) => {
            if (data) {
                if (data.data().bookmarks.length > 0) {
                    onSnapshot(firebase.getBookmarkedBook(), book => {
                        var books = [];
                        book.forEach((doc) => {
                            for(var x=0; x<data.data().bookmarks.length; x++){
                                if(data.data().bookmarks[x] === doc.data().bookID) books.push({ ...doc.data(), id: doc.id })
                            }
                        });
                        if (books.length > 0) {
                            dispatch({
                                type: actionTypes.GET_FAVORITES,
                                payload: {
                                    favorites: books,
                                    favoritesEmpty: false
                                }
                            });
                        } else {
                            dispatch({
                                type: actionTypes.GET_FAVORITES,
                                payload: {
                                    favorites: books,
                                    favoritesEmpty: true
                                }
                            });
                        }
                    })
                }
                else {
                    dispatch({
                        type: actionTypes.GET_FAVORITES,
                        payload: {
                            favorites: [],
                            favoritesEmpty: true
                        }
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_FAVORITES,
                    payload: {
                        favorites: [],
                        favoritesEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}
